/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate the calories your body burns. Your BMR is what you'd burn at rest; your TDEE adds daily activity — the number to eat around to maintain, lose or gain weight.`)
};

const es_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima tu Tasa Metabólica Basal y tus necesidades totales de calorías diarias (TDEE) utilizando la ecuación de Mifflin-St Jeor.`)
};

const de_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzen Sie Ihren Grundumsatz (BMR) und Ihren gesamten täglichen Energieumsatz (TDEE) mit der Mifflin-St Jeor-Gleichung.`)
};

const nl_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat uw basaal metabolisch tarief en totale dagelijkse caloriebehoeften (TDEE) in met behulp van de Mifflin-St Jeor-vergelijking.`)
};

const fr_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez votre taux métabolique de base et vos besoins caloriques quotidiens totaux (TDEE) en utilisant l'équation de Mifflin-St Jeor.`)
};

const it_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima il tuo Metabolismo Basale e il fabbisogno calorico giornaliero totale (TDEE) utilizzando l'equazione di Mifflin-St Jeor.`)
};

const pt_br2_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime sua Taxa Metabólica Basal e necessidades totais de calorias diárias (TDEE) usando a equação de Mifflin-St Jeor.`)
};

const pt_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime a sua Taxa Metabólica Basal e as necessidades calóricas diárias totais (TDEE) utilizando a equação de Mifflin-St Jeor.`)
};

const ja_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mifflin-St Jeor方程式を使用して、基礎代謝率および総日次カロリー必要量（TDEE）を推定します。`)
};

const zh_bmr_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Mifflin-St Jeor 公式估算您的基础代谢率和每日总热量需求（TDEE）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_intro", locale)
	if (locale === "en") return en_bmr_intro(inputs)
	if (locale === "es") return es_bmr_intro(inputs)
	if (locale === "de") return de_bmr_intro(inputs)
	if (locale === "nl") return nl_bmr_intro(inputs)
	if (locale === "fr") return fr_bmr_intro(inputs)
	if (locale === "it") return it_bmr_intro(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_intro(inputs)
	if (locale === "pt") return pt_bmr_intro(inputs)
	if (locale === "ja") return ja_bmr_intro(inputs)
	return zh_bmr_intro(inputs)
};